const config = {
  API_URL: import.meta.env.VITE_API_URL,
  KEYCLOAK_URL: import.meta.env.VITE_KEYCLOAK_URL,
  KEYCLOAK_REALM: 'happify',
  KEYCLOAK_CLIENT_ID: 'happify-admin-website',
  KEYCLOAK_REFRESH_MIN_VALIDITY: 5,
  USER_NAME: `${
    import.meta.env.VITE_KEYCLOAK_URL
  }/realms/happify/protocol/openid-connect/userinfo`,
  VERSION: import.meta.env.VITE_VERSION,
};

export default config;
